"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQueryName = void 0;
const graphql_1 = require("graphql");
/**
 * @summary Returns the name of a GraphQL operation.
 *
 * Returns the name of a GraphQL operation. If the given document does not contain an operation
 * or the operation is not named, throws a `TypeError` instead.
 *
 * @param {DocumentNode} document
 * @returns {string}
 * @throws {TypeError}
 *
 * @see No example usage is available because of https://github.com/apollographql/apollo-tooling/issues/891
 */
function getQueryName(document) {
    const op = document.definitions.find((d) => d.kind === graphql_1.Kind.OPERATION_DEFINITION);
    if (!op) {
        throw new TypeError('The given document does not contain an operation definition.');
    }
    const name = op.name?.value;
    if (name == null) {
        throw new TypeError(`The given ${op.operation} operation is not named.`);
    }
    return name;
}
exports.getQueryName = getQueryName;
